import { Office } from "./office";

export type WeekDayNames =
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday";

export const ALL_WEEK_DAYS: readonly WeekDayNames[] = Object.freeze([
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
]);

export type HourType = "rule" | "holiday" | "weekday";

export type IHourPost = {
  weight?: number;
  days?: WeekDayNames[];
  is_available: boolean;
  start_time: string;
  end_time: string;
  name: string | null;
  type: HourType;
  since: string | null;
  until: string | null;
};

export type IHour = IHourPost & {
  id: string;
  weight: number;
  office_id: string;
  resource_id: string | null;
  created: string;
};

export type IHourWithOffice = IHourPost & {
  id: string;
  weight: number;
  office_id: string;
  resource_id: string | null;
  created: string;
  office?: Office;
};

export type HourQueryParams = {
  tz?: string;
};
